// v4.2.1 — KiosqueStrip : bandeau kiosque du fil d'accueil (maquette étape 1).
// Cartes avec logo (wordmark) du média + titre du jour. 100% piloté par le
// catalogue CONTENT — zéro code par média.

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export default function KiosqueStrip() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${BACKEND_URL}/api/v3/content/discover`)
      .then((r) => setItems(Array.isArray(r.data?.items) ? r.data.items : []))
      .catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <div data-testid="kiosque-strip" className="w-full" style={{ margin: "10px 0 4px" }}>
      <div className="flex gap-2.5 overflow-x-auto no-scrollbar pb-1" style={{ scrollSnapType: "x mandatory" }}>
        {items.map((it, idx) => {
          const headline = it.page_headlines?.[0]?.headline || it.description || "";
          return (
            <button
              key={it.id}
              onClick={() => navigate(`/media?open=${it.id}`)}
              data-testid={`kiosque-strip-card-${it.id}`}
              style={{ scrollSnapAlign: "start" }}
              className={`shrink-0 w-[124px] rounded-xl p-2.5 text-left transition-all bg-white/[0.04] hover:bg-white/[0.09] border ${
                idx === 0 ? "border-amber-400/60" : "border-white/10"
              }`}
            >
              <div className="h-9 rounded-lg bg-white flex items-center justify-center px-2 overflow-hidden">
                {it.logo_url ? (
                  <img src={it.logo_url} alt={it.title} className="max-h-5 w-auto max-w-full object-contain" loading="lazy" />
                ) : (
                  <span className="text-[11px] font-black text-neutral-900 truncate">{it.title}</span>
                )}
              </div>
              <div className="mt-2 text-[10.5px] leading-snug text-white/75 line-clamp-3" style={{ minHeight: 38 }}>
                {headline}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
